import { render, staticRenderFns } from "./AddReport.vue?vue&type=template&id=594697fa&scoped=true"
import script from "./AddReport.vue?vue&type=script&lang=js"
export * from "./AddReport.vue?vue&type=script&lang=js"
import style0 from "./AddReport.vue?vue&type=style&index=0&id=594697fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594697fa",
  null
  
)

export default component.exports